<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Jo7I1h/tc-custom/9781685505707.jpg?1716034494159" alt="This image is the cover for the book Come to the Water"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Come to the Water
      </h1>
      <p class="bookDescription body article font2">
        <p>Ask anyone in Eerie Falls, Louisiana, if the town lives up to its name, and they will tell you yes. Trees that never die, a voodoo priestess, a centenarian mortician who has come back from the dead on several occasions, the mystery surrounding an infant found in the town’s namesake waterfall, and the guardian of the falls who died to prevent anyone else being lost to the water ... many local legends abound.<br/><br/>Keith-Aaron finds himself entangled in several of the legends upon meeting a handsome stranger named Bash, who is new to Eerie Falls but has a possible past connection. Life and death, heartbreak and romance, and a dog that might be a ghost ... the two men will need every bit of magic and mystical guidance the townsfolk and enchanted locale can supply.<br/><br/>With all that’s thrown at them, can their growing affection thrive? When the water tries to take them, will they even survive?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        David Connor, E.F. Mulder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?684e5c88